import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'

import {
  REQUIRED_ADDONS_ALERT_HEIGHT_PX,
  STICKY_FOOTER_HEIGHT_PX,
  STICKY_FOOTER_MOBILE_HEIGHT_PX,
} from '@shared/constants'

export const RequiredAlert = () => {
  const theme = useTheme()
  const isBellowMD = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{
        position: 'fixed',
        left: 0,
        bottom: `${isBellowMD ? STICKY_FOOTER_MOBILE_HEIGHT_PX : STICKY_FOOTER_HEIGHT_PX}px`,
        width: '100%',
        height: `${REQUIRED_ADDONS_ALERT_HEIGHT_PX}px`,
        background: theme.palette.background.error,
        boxShadow: '0px -3px 6px rgba(0, 0, 0, 0.06)',
        zIndex: 1000,
      }}
    >
      <ErrorOutlineIcon fontSize="small" color="error" />
      <Typography variant="body2" sx={{ color: theme.palette.error.darken60 }}>
        Required room or pet selections missing
      </Typography>
    </Stack>
  )
}
